import { STUDIO_HUB_ROUTE_ENTRIES } from './constant';

function normalizeDashboardRootPath(path?: string): string {
  return String(path ?? '').trim().replace(/\/+$/, '').toLowerCase();
}

/** 顶栏枢纽：`STUDIO_HUB_ROUTE_ENTRIES` 中 `headerHub === true` 的 basePath（如 /pr、/ai-report） */
const HEADER_HUB_ROOT_PATHS: readonly string[] =
  STUDIO_HUB_ROUTE_ENTRIES.filter(e => e.headerHub).map(e =>
    normalizeDashboardRootPath(e.basePath),
  );

const HEADER_HUB_ROOT_SET = new Set(HEADER_HUB_ROOT_PATHS);

/** 左侧游戏侧栏：`wrapGameSidebar === true` 的 basePath（当前仅 PR） */
const WRAP_GAME_SIDEBAR_HUB_ROOT_PATHS: readonly string[] =
  STUDIO_HUB_ROUTE_ENTRIES.filter(e => e.wrapGameSidebar).map(e =>
    normalizeDashboardRootPath(e.basePath),
  );

const WRAP_GAME_SIDEBAR_HUB_ROOT_SET = new Set(WRAP_GAME_SIDEBAR_HUB_ROOT_PATHS);

/**
 * `studio_dashboard_list[].path` 是否命中顶栏枢纽（与 {@link STUDIO_HUB_ROUTE_ENTRIES} 中 `headerHub` 一致）。
 */
export function isHeaderHubDashboardPath(path?: string): boolean {
  return HEADER_HUB_ROOT_SET.has(normalizeDashboardRootPath(path));
}

/**
 * `studio_dashboard_list[].path` 是否命中「左侧游戏侧栏」类枢纽（`wrapGameSidebar`，当前仅 /pr）。
 */
export function isSidebarGameHubDashboardPath(path?: string): boolean {
  return WRAP_GAME_SIDEBAR_HUB_ROOT_SET.has(normalizeDashboardRootPath(path));
}
